module.exports = __webpack_public_path__ + "static/img/nongye.22fe7e95.png";